<template>
  <!--数据筛选框2.0，当选择到三级目录的时候，project_id为三级目录的id，选择到二级时project_id为二级ID，二级的选取框绑定的是project，必须通过获取project_id即可拿到-->
  <div style="display: inline-block">
    <div class="search-condition">
      <el-select
        clearable
        v-model="form.organization"
        placeholder="全部机构"
        filterable
        @change="selectorg()"
      >
        <el-option
          v-for="itemm in this.$store.state.userinfo.orgData"
          :value="itemm.id"
          :label="itemm.name"
          :key="itemm.id"
        ></el-option>
      </el-select>
    </div>

    <div class="search-condition">
      <el-select
        clearable
        placeholder="全部分部"
        filterable
        v-model="form.project"
        @change="selectproject()"
      >
        <el-option
          v-for="itemn in form.projectdata"
          :value="itemn.id"
          :label="itemn.fullname"
          :key="itemn.id"
        ></el-option>
      </el-select>
    </div>

    <div class="search-condition">
      <el-select
        clearable
        placeholder="全部项目组"
        filterable
        v-model="form.projecttwo"
        @change="selectprojectclild()"
      >
        <el-option
          v-for="itemp in form.projecttwodata"
          :value="itemp.id"
          :label="itemp.fullname"
          :key="itemp.id"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapMutations, mapState } from "vuex";

export default {
  name: 'OpName',
  data() {
    return {
      form: {
        project: "",
        projecttwo: "",
        projectdata: "",
        projecttwodata: "",
        organization: "",//外部使用作为org_id条件
        project_id: "",//外部使用作为project_id条件
      },
    };
  },
  props:{
    state:{
      type : String,
      default : null
    },//客户分部创建状态
    is_frameContract:{
      type : String,
      default : null
    },//默认不做处理  1 能查询服务中和创建中客户
  },
  created() {
    this.$nextTick(function () {
      this.$store.dispatch("findSysOrg");
      this.findProjectData();
      this.findProjectChildData();
    });
  },
  computed: {
    ...mapState(["orgData", "orgNoAllData"]),
  },
  mounted() {},
  methods: {
    //查询：查询分部数据
    findProjectData() {
      this.$http
        .post("home/findSysProject", {
          org_id: this.form.organization,
          parent_id: 0,
          is_frameContract: this.is_frameContract,
          state: this.state,
        })
        .then((res) => {
          this.form.project = "";
          this.form.projectdata = res.data.message;
        });
    },

    //查询：查询子项目数据
    findProjectChildData() {
      this.$http
        .post("home/findSysProject", {
          isProjectChild: 1,
          parent_id: this.form.project,
          org_id: this.form.organization,
          is_frameContract: this.is_frameContract,
          state: this.state,
        })
        .then((res) => {
          this.form.projecttwo = "";
          this.form.projecttwodata = res.data.message;
        });
    },

    //选择机构时获取对应的项目
    selectorg() {
      this.form.project = "";
      this.form.projecttwo = "";
      this.form.projectdata = "";
      this.form.projecttwodata = "";
      this.form.project_id = "";
      this.findProjectData();
      this.findProjectChildData();
    },

    //选择分部
    selectproject() {
      this.form.project_id = this.form.project; //目的 把项目的值赋值到 project_id 调用这个组件的时候 直接拿project_id而不是拿当前select绑定的project 三级有选择值的时候 把三级的值也是赋值给project_id
      this.findProjectChildData();
    },

    //选择子项目
    selectprojectclild() {
      //如果用户选择 全部子项目的话 则发送 form.project 即二级ID
      if (this.form.projecttwo == -1) {
        this.form.project_id = this.form.project;
      }
      //则发送三级ID
      if (this.form.projecttwo != "" && this.form.projecttwo != -1) {
        this.form.project_id = this.form.projecttwo;
      }
      //则发送三级ID
      if (this.form.projecttwo === "") {
        this.form.project_id = this.form.project;
      }
    },
  },
  components: {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opname/opname4.vue